const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`3129bfbf4cc31c84e5b2a186e8fafeee13ba8828292795f97b94ac8720ca733c`, `3129bfbf4cc31c84e5b2a186e8fafeee13ba8828292795f97b94ac8720ca733c`, 1, 103), new Map([[`count`, (context.has(`count`) ? context.get(`count`) : null)]]), false, false, 1));
            }

            getTemplateName() {
                return `3129bfbf4cc31c84e5b2a186e8fafeee13ba8828292795f97b94ac8720ca733c`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `3129bfbf4cc31c84e5b2a186e8fafeee13ba8828292795f97b94ac8720ca733c`, ``);
            }
        }],
        [103, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/footnote-group/footnote-group.twig`, `3129bfbf4cc31c84e5b2a186e8fafeee13ba8828292795f97b94ac8720ca733c`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/footnote-group/footnote-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`3129bfbf4cc31c84e5b2a186e8fafeee13ba8828292795f97b94ac8720ca733c`, `3129bfbf4cc31c84e5b2a186e8fafeee13ba8828292795f97b94ac8720ca733c`, 5, 102), new Map([[`count`, (context.has(`count`) ? context.get(`count`) : null)]]), false, false, 5));
                this.echo(`  `);
            }

            getTemplateName() {
                return `3129bfbf4cc31c84e5b2a186e8fafeee13ba8828292795f97b94ac8720ca733c`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `3129bfbf4cc31c84e5b2a186e8fafeee13ba8828292795f97b94ac8720ca733c`, ``);
            }
        }],
        [102, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/footnote/footnote.twig`, `3129bfbf4cc31c84e5b2a186e8fafeee13ba8828292795f97b94ac8720ca733c`, 5);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/footnote/footnote.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        This is the footnote content.
      `);
            }

            getTemplateName() {
                return `3129bfbf4cc31c84e5b2a186e8fafeee13ba8828292795f97b94ac8720ca733c`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `3129bfbf4cc31c84e5b2a186e8fafeee13ba8828292795f97b94ac8720ca733c`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '3129bfbf4cc31c84e5b2a186e8fafeee13ba8828292795f97b94ac8720ca733c');

let template = env.loadTemplate('3129bfbf4cc31c84e5b2a186e8fafeee13ba8828292795f97b94ac8720ca733c');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/footnote/demo/demo.twig", args: context }
     );
     return rendered;;
};